import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaTipoPesquisa = (): TabelaColuna => ({
  Chave: 'tipoPesquisa',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Tipo Pesquisa</div>
})
